import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-generic-processing',
  templateUrl: './generic-processing.component.html',
  styleUrl: './generic-processing.component.scss'
})
export class GenericProcessingComponent  {

  constructor(
    public _dialogRef: MatDialogRef<GenericProcessingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDdialogData,
  ) 
    {
      if(this.data.button == '')
        this.data.button = 'Submit';
      }
}


export interface IDdialogData{
title: string;
line1: string;
line2: string;
button: string;
}
